module.exports = __webpack_public_path__ + "static/img/centerFloor.fe8e7656.png";